import React from 'react';
import { useHistory } from 'react-router-dom';
import Layout from '../components/Layout';
import { colorsData } from '../data/colors';
import { useSpeech } from '../hooks/useSpeech';
import './Colors.css';

const Colors = () => {
    const history = useHistory();
    const { speak } = useSpeech();

    const handleColorClick = (item) => {
        speak(item.label);
    };

    return (
        <Layout title="Colors" onBack={() => history.push('/')}>
            <div className="colors-grid">
                {colorsData.map((item) => (
                    <button
                        key={item.id}
                        className="color-card"
                        style={{ backgroundColor: item.hex, color: item.id === 'white' || item.id === 'yellow' ? 'black' : 'white' }}
                        onClick={() => handleColorClick(item)}
                    >
                        <span className="color-label">{item.label}</span>
                    </button>
                ))}
            </div>
        </Layout>
    );
};

export default Colors;
